export default "__VITE_ASSET__C25JrL98__"